export default __webpack_public_path__ + "static/wsl-background-8615d34dac337074e2170d1a13abb930.png";